import React from 'react'
import { Text } from "@nextui-org/react";

function DealsandOffers() {
  return (
    <div className='accountForms'>
    <Text>
      Discount Deals and Offers
    </Text>
  </div>
  )
}

export default DealsandOffers